import { Link } from "react-router-dom";
import "./css/footer.css";

const Footer = () => {
  const contactDetails = {
    phone: "+263711951133",
    email: "info@brainstake.tech",
    address: "2761 Sable Way, BluffHill, Harare",
  };
  return (
    <div className="footer">
      <div className="top">
        <div className="left">
          <Link to="/">
            <img
              src="/new_landing_page_images/brainstake_logo.svg"
              alt="brainstake logo"
            />
          </Link>
          <h2>Empowering Africa's Future Through Accessible Education</h2>
          <p>
            Empowering students, schools, and communities with technology-driven
            solutions for a better tomorrow.
          </p>
          <button
            className="get_a_free_demo"
            onClick={() => {
              document
                .querySelector(".book_demo_container")
                ?.classList?.toggle("displayed_none");
            }}
          >
            Get a Free Demo
          </button>
        </div>
        <div className="right">
          <div className="one">
            <h3>Helpful Links</h3> 
            <div className="bottom"> 
              {/* <Link to="https://eschools-zw.app.brainstake.tech/parent_self_registration" className="to_registration" target="_blank">
                Registration
              </Link> */}
              <Link to="https://eschools-zw.app.brainstake.tech" target="_blank">School Login</Link>  
              <Link to="#">Send Enquiry</Link>
              <Link to="#">FAQ</Link>
            </div>
          </div>
          <div className="two">
            <h3>Contact Us</h3>
            <div className="bottom">
              <Link to={`tel:${contactDetails.phone}`}>
                <img src="/new_landing_page_images/phone.svg" alt="call_us" />
                <span>{contactDetails.phone}</span>
              </Link>
              <Link to={`mailto:${contactDetails.email}`}>
                <img
                  src="/new_landing_page_images/envelope.svg"
                  alt="email_us"
                />
                <span>{contactDetails.email}</span>
              </Link>
              <Link
                to={`https://www.google.com/maps/search/?api=1&query=${contactDetails.address}`}
                target="_blank"
              >
                <img
                  src="/new_landing_page_images/location.svg"
                  alt="locate_us"
                />
                <span>{contactDetails.address}</span>
              </Link>
            </div>
          </div>
          <div className="three">
            <h3>Get The App</h3>
            <div className="bottom">
              <Link to="/">
                <img
                  src="/new_landing_page_images/apple_store.svg"
                  alt="apple store link"
                />
              </Link>
              <Link to="/">
                <img
                  src="/new_landing_page_images/google_play_store.svg"
                  alt="google_play_store_ink"
                />
              </Link>
              <div className="social_links">
                <Link to="/">
                  <img
                    src="/new_landing_page_images/instagram.png"
                    alt="instagram_logo"
                  />
                </Link>
                {/* <Link to="/">
                  <img
                    src="/new_landing_page_images/twitter_logo.svg"
                    alt="twitter_logo"
                  />
                </Link> */}
                <Link to="https://www.linkedin.com/in/brainstake-smart-systems-717824345?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank">
                  <img
                    src="/new_landing_page_images/linkedin_logo.svg"
                    alt="linkedin_logo"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom_section">
        <div className="left">
          Copyright &copy; Web Design By Brainstake 2024
        </div>
        <div className="right">
          <Link to="#">Terms & Conditions</Link>
          <Link to="/privacy-policy" target="_blank">Privacy Policy</Link>
          <Link to="#">Cookies Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default Footer;
